/** Both modes share the same model-generated footer and card outline. */
export function IslandCardSurface({ height }: { height: number }) {
  return <div className="workday-unified-surface" style={{ height }} aria-hidden="true" />;
}
